import { useState } from "react";

import { cn } from "@/ui/cn";

function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return (words.length > 1 ? `${words[0]![0]}${words[1]![0]}` : (words[0] ?? "?").slice(0, 2)).toUpperCase();
}

/** Rounded squares (a person's avatar is a circle, so a brand never looks like one). */
const BOX = {
  sm: "size-7 rounded-[9px] text-[11px]",
  md: "size-10 rounded-[14px] text-sm",
  lg: "size-14 rounded-[18px] text-lg",
} as const;

/** The brand's logo, or its initials on a green tile when there's none (or it fails to load). */
export function BrandMark({
  name,
  logoUrl,
  size = "md",
}: {
  name: string;
  logoUrl: string | null;
  size?: "sm" | "md" | "lg";
}) {
  const [broken, setBroken] = useState(false);
  const box = BOX[size];
  if (logoUrl && !broken) {
    return (
      <img
        src={logoUrl}
        alt=""
        loading="lazy"
        onError={() => setBroken(true)}
        className={cn(box, "shrink-0 border border-border-subtle bg-surface-muted object-cover")}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      className={cn(
        box,
        "flex shrink-0 items-center justify-center bg-primary-soft font-extrabold text-primary-soft-ink",
      )}
    >
      {initials(name)}
    </span>
  );
}
